import { render, staticRenderFns } from "./CornerRibbon.vue?vue&type=template&id=9f35d6da&"
import script from "./CornerRibbon.vue?vue&type=script&lang=js&"
export * from "./CornerRibbon.vue?vue&type=script&lang=js&"
import style0 from "./CornerRibbon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports